import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IBanner } from '@common/interfaces/banner.interface';
import { ISliderBannerConfig } from '@common/interfaces/slider-banner.interface';
import { IonSlides } from '@ionic/angular';
import { BannersService } from '@services/banners/banners.service';

@Component({
  selector: 'app-slider-banners',
  templateUrl: './slider-banners.component.html',
  styleUrls: ['./slider-banners.component.scss'],
})
export class SliderBannersComponent implements OnInit, AfterViewInit {
  @Input() options!: ISliderBannerConfig;

  @ViewChild('bannerSlider', { static: false }) slides?: IonSlides;

  banners: IBanner[] = [];

  mySlideOptions: any = {
    initialSlide: 0,
    slidesPerView: 1,
    centeredSlides: true,
    loop: false,
    spaceBetween: 0,
    speed: 700,
    effect: 'slide',
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    pagination: {
      type: 'fraction',
    },
  };

  constructor(private bannersService: BannersService) {}

  ngOnInit(): void {
    this.banners = this.bannersService.getBanners(this.options.section) || [];

    const hasMultipleBanners = this.banners.length > 1;

    this.mySlideOptions = {
      ...this.mySlideOptions,
      loop: hasMultipleBanners,
      allowTouchMove: hasMultipleBanners,
      autoplay: hasMultipleBanners
        ? this.mySlideOptions.autoplay
        : false,
    };
  }

  async ngAfterViewInit(): Promise<void> {
    await this.slides?.update();

    if (this.banners.length > 1) {
      await this.slides?.startAutoplay();
    }
  }

  async slidePrev(): Promise<void> {
    if (this.banners.length <= 1) {
      return;
    }

    await this.slides?.slidePrev();
    await this.slides?.startAutoplay();
  }

  async slideNext(): Promise<void> {
    if (this.banners.length <= 1) {
      return;
    }

    await this.slides?.slideNext();
    await this.slides?.startAutoplay();
  }
}
